import { createContext, useContext } from 'react';

import { UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { PublishedVersion } from 'api/types';

type JourneyEditContextType = {
  isEditingTitle: boolean;
  publishMutation: UseMutationResult<
    AxiosResponse<any>,
    unknown,
    { changeTravellerJourneyIds?: string[] } | undefined,
    unknown
  >;
  previewVersion: PublishedVersion | null;
  setPreviewVersion: (version: PublishedVersion | null) => void;
  isPreviewMode: boolean;
};

export const JourneyEditContext = createContext<JourneyEditContextType | undefined>(undefined);

export function useJourneyEditContext(): JourneyEditContextType {
  const ctx = useContext(JourneyEditContext);
  if (!ctx) {
    throw new Error('Missing JourneyEditContext');
  }

  return ctx;
}
